module.exports = __webpack_public_path__ + "img/petstairs03.520cf613.jpg";